export class AnimationManager {
    static getCurrentDuration() {
        return AnimationManager.animationsEnabled ? 300 : 0;
    }
}
AnimationManager.animationsEnabled = false;
window.AnimationManager = AnimationManager;
$(function () {
    setTimeout(function () {
        AnimationManager.animationsEnabled = true;
    }, 500);
});
